import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { apiCall } from '../../services/api-service';
import './CompletionCardsRow.css';

export const CompletionCardsRow = () => {
  const [cards, setCards] = useState([
    { title: 'Completed Payments', count: 0, value: '₹0' },
    { title: 'Pending Payments', count: 0, value: '₹0' },
    { title: 'Failed Transactions', count: 0, value: '₹0' },
    { title: 'Refund Payments', count: 0, value: '₹0' }
  ]);

  const mapApiTitle = (title) => {
    const t = title.toLowerCase();
    if (t.includes('completed')) return 'Completed Payments';
    if (t.includes('pending')) return 'Pending Payments';
    if (t.includes('failed')) return 'Failed Transactions';
    if (t.includes('refund')) return 'Refund Payments';
    return title;
  };

  useEffect(() => {
    const fetchCompletionCards = async () => {
      try {
        const res = await apiCall('get', 'dashboard/completion-cards');
        if (res?.data?.status === 'success' || res?.data?.success === true) {
          const mappedData = res.data.data.map(item => ({
            ...item,
            title: mapApiTitle(item.title)
          }));
          setCards(mappedData);
        }
      } catch (err) {
        console.error('Error fetching completion cards:', err);
      }
    };
    fetchCompletionCards();
  }, []);

  return (
    <div className="completion-cards-container mt-3">
      <Row className="g-3">
        {cards.map((card, index) => (
          <Col xs={12} sm={6} md={3} className="d-flex" key={card.id || index}>
            <Card className="completion-card w-100 border-0">
              <Card.Body className="d-flex flex-column gap-3 p-3">
                <div className="d-flex flex-column gap-2">
                  <div className="completion-icon-box">
                    <span className="completion-icon-text">₹</span>
                  </div>

                  <span className="completion-card-title text-truncate">
                    {card.title}
                  </span>

                  <span className="completion-card-count">
                    {card.count}
                  </span>
                </div>

                <div className="completion-sub-card">
                  <span className="completion-sub-card-label">Value</span>
                  <span className="completion-sub-card-value text-truncate">
                    {card.value || `₹${card.percentage || 0}`}
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};
